import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import SvgIconStyle from '../SvgIconStyle';

export const ConfirmDialog = ({ open, onClose, action, rejected, setRejected }) => (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ minWidth: 600, padding: '1rem' }}>
        <DialogTitle>
          <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
            <Box onClick={onClose}>
              <SvgIconStyle src="/icons/close_square_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
            </Box>
            <Typography fontSize={20} fontWeight={700}>
              دلیل رد درخواست
            </Typography>
            <div />
          </Stack>
        </DialogTitle>
        <Stack justifyContent="center" sx={{ width: '90%', margin: '1rem auto' }} gap={3}>
          <FormControl fullWidth>
            <InputLabel>دلیل رد درخواست را مشخص نمایید</InputLabel>
            <Select
              label="دلیل رد درخواست را مشخص نمایید"
              value={rejected.reason}
              onChange={(e) => setRejected({ ...rejected, reason: e.target.value })}
            >
              <MenuItem value="محتوای نامناسب">محتوای نامناسب</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="توضیحات برای اطلاع به کاربر"
            placeholder="متن توضیحات کارشناسی خود را وارد کنید"
            fullWidth
            multiline
            minRows={4}
            value={rejected.description}
            onChange={(e) => setRejected({ ...rejected, description: e.target.value })}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rejected.notifyUser}
                onChange={(e) => setRejected({ ...rejected, notifyUser: e.target.checked })}
              />
            }
            label="ارسال پیامک برای کاربر "
          />
        </Stack>
        <DialogActions>
          <Button variant="contained" size="medium" sx={{ mx: 'auto' }} onClick={action}>
            تایید
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
